import { TableCell as MuiTableCell, TableRow as MuiTableRow, TableCellProps, TextField } from '@mui/material'

import { HeaderCell } from '~/features/guild/components/table/cells'
import type { TableColumn, TableProps, TableRow } from '~/features/guild/components/table/types'

export const FilterRow = <T extends TableRow<T, Props>, Props = {}>(props: {
  componentProps: TableProps<T, Props>
}) => (
  <MuiTableRow key="filter">
    {props.componentProps.columns.map((column) => {
      const tableCellProps: TableCellProps = {
        align: column.headerAlign,
        width: column.columnWidth,
        height: props.componentProps.filterHeight,
        sx: props.componentProps.filterCellSx,
      }

      if (column.filter) {
        return (
          <MuiTableCell key={column.field.toString()} {...tableCellProps}>
            <TextField {...column.filter.props} />
          </MuiTableCell>
        )
      }
      if (column.pinLeft || column.pinRight) {
        return null
      }

      return <MuiTableCell key={column.field.toString()} {...tableCellProps} />
    })}
  </MuiTableRow>
)

/**
 * 构建表头行
 * @param props 参数
 * @returns
 */
export const HeaderRow = <T extends TableRow<T, Props>, Props = {}>(props: {
  /** 行配置 */
  columns: TableColumn<T, Props>[]
  /** 表头高度 */
  headerHeight?: number
  /** 组件内回调函数的参数传递 */
  tableProps?: Props
  /** 是否包含固定列 */
  includePinned?: boolean
}) => (
  <MuiTableRow>
    {props.columns.map((column) => {
      if (!props.includePinned && (column.pinLeft || column.pinRight)) {
        return null
      }

      return (
        <MuiTableCell
          key={column.field.toString()}
          align={column.headerAlign}
          width={column.columnWidth}
          height={props.headerHeight}
          sx={{
            padding: '12px 8px',
            ...column.headerCellSx,
          }}
        >
          <HeaderCell column={column} tableProps={props.tableProps} />
        </MuiTableCell>
      )
    })}
  </MuiTableRow>
)
